import type {GetAccountEnrichment_accountEnrichment as EnrichmentField} from 'nutshell-graphql-types';

export const SOCIAL_PROFILE_TYPE = 'social';
export const RELATED_COMPANY_TYPE = 'company';

type SubheaderType = 'social' | 'company';

export function getSubheader(fields: EnrichmentField[], type: SubheaderType) {
    const count = type === RELATED_COMPANY_TYPE ? 1 : fields.length;

    let noun = 'data';
    if (type === SOCIAL_PROFILE_TYPE) {
        noun = count === 1 ? 'profile' : 'profiles';
    } else if (type === RELATED_COMPANY_TYPE) {
        noun = 'company';
    }

    return `${count} ${noun} identified`;
}
